export const API_BASE_URL = 'https://customerchurn.ru/api';
export const HOST_BASE_URL = 'https://localhost:3000'
